import { formatDistance, parseISO } from "date-fns";
import type { ApiToken } from "src/queries/auth/tokens.types";

export type TokenStatus = "active" | "expired" | "revoked";

export function getTokenStatus(token: ApiToken): TokenStatus {
  if (token.is_revoked) return "revoked";
  if (new Date(token.expires_at) < new Date()) return "expired";
  return "active";
}

export const statusConfig = {
  active: { label: "Active", color: "success" as const },
  expired: { label: "Expired", color: "default" as const },
  revoked: { label: "Revoked", color: "error" as const },
};

export function formatRelativeTokenTime(iso: string): string {
  return formatDistance(parseISO(iso), new Date(), { addSuffix: true });
}
